<template>
  <div ref="DataPlans" id="DataPlans">
    <vx-card v-show="dataplanListVisable">
      <div>
        <vs-button color="success" class="vx-col mb-4" @click="openAddNewPlan">New Plan</vs-button>
        <vs-table pagination stripe ref="dataPlanTable" class="vs-con-loading__container" single
          @selected="selectedDataPlan" :max-items="criteria.pageSize" search :data="dataPlans">
          <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
            <vs-dropdown vs-trigger-click
              class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
              <div
                class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ criteria.pageNumber * criteria.pageSize - (criteria.pageSize - 1) }} - {{
                criteria.pageNumber * criteria.pageSize > 0 ? criteria.pageNumber * criteria.pageSize :
                dataPlans.length }} of {{ dataPlans.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="criteria.pageSize=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="criteria.pageSize=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Package</vs-th>
            <vs-th>Duration</vs-th>
            <vs-th>Price</vs-th>
            <vs-th>Sold</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="dataPlan" :key="indextr" v-for="(dataPlan, indextr) in data">

              <vs-td :data="data[indextr].dataPlanFullName">
                {{ dataPlan.name }}
              </vs-td>

              <vs-td :data="data[indextr].dataPlanFullName">
                {{ dataPlan.package }}
              </vs-td>

              <vs-td :data="data[indextr].dataPlanFullName">
                {{ dataPlan.duration }}
              </vs-td>

              <vs-td :data="data[indextr].dataPlanFullName">
                R {{ dataPlan.price }}
              </vs-td>

              <vs-td :data="data[indextr].dataPlanFullName">
                {{ dataPlan.sold }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vx-card :title="editDataplan ? `Update ${dataPlanObject.name}` : 'New Data Plan'" v-show="!dataplanListVisable">
      <div class="vx-row">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <div class="vx-col w-full mb-3">
            <label>Name</label>
            <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full" name="Name"
              v-model="dataPlanObject.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
        </div>
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <label>Package</label>
          <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full" name="Package"
            v-model="dataPlanObject.package" />
          <span class="text-danger text-sm" v-show="errors.has('Package')">{{ errors.first('Package') }}</span>
        </div>
      </div>
      <div class="vx-row ">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full w-full">
          <label>Description</label>
          <vs-textarea autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"
            name="Description" v-model="dataPlanObject.description" />
          <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description')
          }}</span>
        </div>
        <div class="vx-col xl:w-1/4 lg:w-1/4 md:w-1/2 sm:w-full xs:w-full w-full">
          <label>Duration</label>
          <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full" name="Duration"
            v-model="dataPlanObject.duration" />
          <span class="text-danger text-sm" v-show="errors.has('Duration')">{{ errors.first('Duration') }}</span>
        </div>
        <div class="vx-col xl:w-1/4 lg:w-1/4 md:w-1/2 sm:w-full xs:w-full w-full">
          <label>Price (R)</label>
          <vs-input type="number" autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"
            name="Price" v-model="dataPlanObject.price" />
          <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
        </div>
      </div>
      <div class="vx-row mobileMarginTop-2">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-checkbox v-model="dataPlanObject.onceOff" color="success">Once Off</vs-checkbox>
        </div>
      </div>
      <div class="vx-row w-full btn-container-float-end">
        <vs-button :disabled="!isAllItemsFilled" color="success" class="vx-col   " @click="addOrEditHandler">{{editDataplan ? 'Update':'Add'}}</vs-button>
        <vs-button v-if="editDataplan" color="danger" class="vx-col   " @click="validateDeleteDataPlan()">Delete</vs-button>
        <vs-button color="warning" type="border" class="vx-col  " @click="cancel" >Cancel</vs-button>
      </div>
    </vx-card>
  </div>
</template> 


<script>
import 'animate.css';
export default {
  data() {
    return {
      dataPlans: [],
      dataplanListVisable: true,
      criteria: {
        pageSize: 10,
        pageNumber: 1,
      },
      editDataplan: false,
      dataPlanObject: {
        id: 0,
        name: "",
        package: "",
        description: "",
        duration: 1,
        price: 0.00,
        onceOff: false,
        isActive: true,
      },
      isAllItemsFilled: true,
    }
  },
  components: {

  },
  watch: {
    dataPlanObject: {
      handler: function (value) {
        var self = this;
        this.$validator.validateAll().then(result => { self.isAllItemsFilled = result })
      },
      deep: true
    },
  },
  computed: {

  },
  methods: {
    init() {
      this.dataplanListVisable = true;
      this.editDataplan = false;
      this.dataPlanObject = {
        id: 0,
        name: "",
        package: "",
        description: "",
        duration: 1,
        price: 0.00,
        onceOff: false,
      };
    },
    getDataPlans() {
      var self = this;
      self.showLoadingOnElement("dataPlanTable", 1, "corners");
      var onSuccess = response => {
        self.dataPlans = response.data;
      }

      var onFinally = response => {
        if (self.$refs.dataPlanTable) {
          self.$vs.loading.close(self.$refs.dataPlanTable.$el);
        }
      }
      self.$ajaxGet(self, "Admin/GetDataPlans", onSuccess, onFinally);
    },
    selectedDataPlan(dataPlan) {
      this.dataPlanObject = JSON.parse(JSON.stringify(dataPlan))
      this.dataplanListVisable = false;
      this.editDataplan = true;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    updateDataPlan() {
      var self = this;
      self.showLoadingOnElement("DataPlans", 1, "corners");
      var onSuccess = response => {
        self.getDataPlans();
      }

      var onFinally = response => {
        if (self.$refs.DataPlans) {
          self.$vs.loading.close(self.$refs.DataPlans.$el);
        }
        self.init();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Data Plan Updated",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
      }

      self.$ajaxPost(self, "Admin/UpdateDataPlan", this.dataPlanObject, onSuccess, onFinally);
    },
    addDataPlan() {
      var self = this;
      self.showLoadingOnElement("DataPlans", 1, "corners");
      var onSuccess = response => {
        self.getDataPlans();
      }

      var onFinally = response => {
        if (self.$refs.DataPlans) {
          self.$vs.loading.close(self.$refs.DataPlans.$el);
        }
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Data Plan Added",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
        self.init();
      }

      self.$ajaxPost(self, "Admin/AddDataPlan", this.dataPlanObject, onSuccess, onFinally);
    },
    validateDeleteDataPlan(){
      this.$swal({
        title: 'Are you sure',
        icon: 'info',
        html: `You are about to Delete <strong> ${this.dataPlanObject.name}</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-danger vs-button-filled',
          denyButton: 'vs-component vs-button vs-button-warning vs-button-border ml-2',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        buttonsStyling: false,
        showDenyButton: true,
        denyButtonText: `Cancel`,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.isConfirmed) { // <-- if confirmed
          this.deleteDataPlan();
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            html: `${this.dataPlanObject.name} has been deleted.`,
            customClass: {
            confirmButton: 'vs-component vs-button vs-button-success vs-button-filled',
            }
          })
        }
        else{
          this.$swal({
            icon: 'success',
            title: 'Canceled',
            html: `${this.dataPlanObject.name} has not been deleted.`,
            customClass: {
            confirmButton: 'vs-component vs-button vs-button-success vs-button-filled',
            }
          })
        }
      });
    },
    deleteDataPlan() {
      var self = this;
      self.showLoadingOnElement("DataPlans", 1, "corners");

      var onSuccess = response => {
        self.getDataPlans();
      }
      var onFinally = response => {
        if (self.$refs.DataPlans) {
          self.$vs.loading.close(self.$refs.DataPlans.$el);
        }
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Data Plan Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-smartphone'
        });
        self.init();
      }

      self.$ajaxGet(self, `Admin/DeleteDataPlan?dataPlanId=${this.dataPlanObject.id}`, onSuccess, onFinally);
    },
    cancel() {
      this.init();
    },
    addOrEditHandler(){
      if(this.editDataplan){
        this.updateDataPlan();
      }
      else{
        this.addDataPlan();
      }
    },
    openAddNewPlan(){
      this.dataplanListVisable = false;
      this.editDataplan = false;
    }
  },
  mounted() {
    this.init();
    this.dataPlans = [];
    this.getDataPlans();
  },
}
</script>


<style lang="scss">
.mobileMarginTop-2 {
  @media screen and (max-width:1024px) {
    margin-top: 15px;
  }
}
.btn-container-float-end{
  justify-content: end;
  button{
    margin: 5px;
  }
}
</style>